export default __webpack_public_path__ + "static/sky-faded.url-21298c7190a6be1f1b368fe30c4fc169.svg";